const useMediaQuery = () => {
    const isMobileDevice = window.screen.width < 1024

    return { isMobileDevice }
}

export default useMediaQuery
